import React from 'react';
import Order from './Order/Order';
import Slidebar from './Slidebar/Slidebar';

const Customer = () => {
    return (
        <div className="container-fluid">   
                <Order></Order>
        </div>
    );
};

export default Customer;